var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuarterMoon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2V22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21.8883C17.4839 21.289 20.6981 18.3395 21.6858 14.4968L13.5 17.0155V21.8883Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 12.2834 21.9882 12.564 21.9651 12.8414L13.5 15.4461V13.0155L21.8786 10.4374C21.9585 10.9466 22 11.4684 22 12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11.4461V9.01548L20.568 6.8407C20.9691 7.5053 21.295 8.22035 21.534 8.97407L13.5 11.4461Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.44601L19.6463 5.55485C18.1168 3.74219 15.9545 2.4809 13.5 2.11169V7.44601Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuarterMoon1);
export default __webpack_public_path__ + "static/media/quarter-moon-1.2a77e92f7cec5b330920f7c202bcfec8.svg";
export { ForwardRef as ReactComponent };